<template>
    <div>
        <div class="wrap1200 flexBetween pt20">
            <!-- <div class="w260">
                <div class="aSideNotice">
                    <div class="titleI">
                        <h2>开奖公告</h2>
                        <el-button size="mini" plain round>更多</el-button>
                    </div>
                    <div class="drawPrize">
                        <ul>
                            <li v-for="(item,index) in this.lotteryData.lottery?this.lotteryData.lottery:[]">
                                <h4>
                                    <a href="javascript:;">{{ item.lottery_name }}</a>
                                    <span class="ml10">第{{item.result.lottery_no}}期</span>
                                    <em>{{item.result.lottery_date.substring(5)}}</em>
                                </h4>
                                <div class="nub" v-if="parseInt(item.result.redballs.length)+parseInt(item.result.blueballs.length) > 7">
                                    <div class="marquee">
                                        <div class="marquee-inner">
                                            <span v-for="el in item.result.redballs">{{ el }}</span>
                                            <template v-if="item.result.blueballs.length > 0">
                                                <span class="blue" v-for="el in item.result.blueballs">{{ el }}</span>
                                            </template>
                                        </div>
                                    </div>
                                    <a href="javascript:;">详情</a>
                                </div>
                                <div class="nub" v-else>
                                    <span v-for="el in item.result.redballs">{{ el }}</span>
                                    <template v-if="item.result.blueballs.length > 0">
                                        <span class="blue" v-for="el in item.result.blueballs">{{ el }}</span>
                                    </template>
                                    <a href="javascript:;">详情</a>
                                </div>
                                <p v-if="item.result.lottery_pool_amount != 0">
                                    <span>奖池滚存：
                                         <span>{{ parseInt(item.result.lottery_pool_amount).toLocaleString() }}元</span>
                                    </span>
                                </p>
                                <p v-if="index < 2" style="margin-top: 3px;">
                                    <span >一等奖：
                                         <span>{{ item.result.lottery_prize[0].prize_amount }}元</span>
                                    </span>
                                    <em v-if="item.kaijiang == 'yes'">今日开奖</em>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <div class="w920">
                <div class="bannerI">
                    <el-carousel :interval="5000">
                        <el-carousel-item v-for="item in 4" :key="item">
                        <img src="../assets/banner01.png"/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="centerCon">
                    <div class="newsInfo fl">
                        <!-- <div class="liveEntry">
                            <a href="#" target="_blank" class="red">
                                <h3>福彩开奖直播</h3>
                                <div class="liveSmall">
                                    <p>每日21:15直播开奖</p>
                                    <p>双色球/3D/七乐彩</p>
                                </div>
                            </a>
                            <a href="#" target="_blank" class="orange">
                                <h3>体彩开奖直播</h3>
                                <div class="liveSmall">
                                    <p>每日21:00直播开奖</p>
                                    <p>大乐透/排三/五/七星彩</p>
                                </div>
                            </a>
                        </div> -->
                        <div class="footballMain" v-if="lotteryData.hotvideo">
                            <div class="titleI">
                                <h2>推荐信息</h2>
                                <el-button size="mini" @click="goMoreExpertData()" plain round>更多</el-button>
                            </div>
                            <ul>
                                <!-- Tab 切换 -->
                                <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
                                  <el-tab-pane label="杀号" name="1">
                                    <div class="expert-list">
                                        <div v-for="(item, index) in expertContent" :key="item.id" class="expert-data-card">

                                          <div class="info" @click="goExpertDataInfo(item.id)">

                                            <div class="top">
                                              <img :src="item.avatar ? 'https://api.goucaiwang888.com' + item.avatar : require('@/assets/avatar.png')" class="avatar" />
                                              <span class="nickname">{{ item.nickname }}</span>
                                             <span class="expert-level">[{{ item.level_name }}]</span>

                                            </div>
                                            <div class="lottery">
                                               <span class="level">{{ item.lottery_name }}</span>
                                               <span class="level">第{{ item.lottery_no }}期</span>
                                            </div>
                                            <div class="title">
                                              {{ item.title }}
                                            </div>
                                            <div class="footer">
                                              <span class="time">{{ item.createtime }}</span>
                                              <span :class="getStatusClass(item.status)">{{ getStatusText(item.status) }}</span>
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                  </el-tab-pane>
                                  <el-tab-pane label="推荐号" name="0">
                                    <div class="expert-list">
                                        <div v-for="(item, index) in expertContent" :key="item.id" class="expert-data-card">

                                          <div class="info" @click="goExpertDataInfo(item.id)">
                                            <div class="top">
                                              <img :src="item.avatar ? 'https://api.goucaiwang888.com' + item.avatar : require('@/assets/avatar.png')" class="avatar" />
                                              <span class="nickname">{{ item.nickname }}</span>
                                              <span class="expert-level">[{{ item.level_name }}]</span>
                                            </div>
                                            <div class="lottery">
                                               <span class="level">{{ item.lottery_name }}</span>
                                               <span class="level">第{{ item.lottery_no }}期</span>
                                            </div>
                                            <div class="title">
                                              {{ item.title }}
                                            </div>
                                            <div class="footer">
                                              <span class="time">{{ item.createtime }}</span>
                                              <span :class="getStatusClass(item.status)"> {{ getStatusText(item.status) }}</span>
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                  </el-tab-pane>
                                </el-tabs>
                            </ul>
                        </div>
                        <div class="footballMain" v-if="lotteryData.hotvideo">
                            <div class="titleI">
                                <h2>足球赛程</h2>
                                <el-button size="mini" @click="goCourse(0,0)" plain round>更多</el-button>
                            </div>
                            <ul>
                                <li v-for="(league, index) in leagues" :key="index" class="footballItem">
                                    <div
                                        :style="{ background: `url(${require('../assets/' + league.icon)})` }"
                                        class="footballTitle"
                                    >{{ league.name }}</div>
                                    <div class="footballList">
                                        <div class="listItem">
                                            <div @click="goCourse(0,index)">积分</div>
                                            <div @click="goCourse(1,index)">射手榜</div>
                                            <div @click="goCourse(2,index)">助攻榜</div>
                                            <div @click="goCourse(3,index)">赛程</div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="courseMain" v-if="lotteryData.hotvideo">
                            <div class="titleI">
                                <h2>使用教程</h2>
                                <el-button size="mini" @click="goVideo" plain round>更多</el-button>
                            </div>
                            <ul>
                                <li v-for="(item,index) in lotteryData.hotvideo.slice(0,4)" @click="goToVideoPage(item.id)">
                                    <img :src="lotteryData.config.cdn_url+item.thumb_url" :alt="item.title">
                                </li>
                            </ul>
                        </div>
                        <div class="newsMain" v-if="lotteryData.article">
                            <div class="titleI">
                                <h2>每日资讯</h2>
                                <el-button size="mini" @click="goArticle" plain round>更多</el-button>
                            </div>
                            <dl class="newsInfolist">
                                <dt>
                                    <a target="_blank" @click="goArticleDetil(lotteryData.article.dlt[0].id)">{{lotteryData.article.dlt[0].title}}</a>
                                </dt>
                                <dd v-for="(item,index) in lotteryData.article.dlt.slice(1,5)">
                                    <a @click="goArticleDetil(item.id)" target="_blank">{{ item.title }}</a>
                                </dd>
                            </dl>
                            <dl class="newsInfolist mt15">
                                <dt>
                                    <a target="_blank" @click="goArticleDetil(lotteryData.article.ssq[0].id)">{{lotteryData.article.ssq[0].title}}</a>
                                </dt>
                                <dd v-for="(item,index) in lotteryData.article.ssq.slice(1,5)">
                                    <a @click="goArticleDetil(item.id)" target="_blank">{{ item.title }}</a>
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <div class="downEwmWrap fr">
                        <div class="downEwmBlock">
                            <div class="titleI">
                              <h2>专家解读</h2>
                            </div>

                            <!-- 专家网格（CSS Grid） -->
                            <div class="expert-grid">
                              <div
                                v-for="(card, idx) in gridExperts"
                                :key="idx"
                                class="expert-card"
                                :class="{ more: card.type === 'more' }"
                                @click="handleCardClick(card)"
                              >
                                <!-- 专家卡片 -->
                                <!-- <template v-if="card.type === 'expert'" >
                                  <img class="avatar"  :src="card.avatar ? 'https://api.goucaiwang888.com' + card.avatar : require('@/assets/avatar.png')" alt="avatar" />
                                  <p class="name"  :title="card.nickname">{{ card.nickname }}</p>
                                  <p class="hit">命中 <b class="hit-num">{{ card.total_hit }}</b></p>
                                </template> -->
                                <template v-if="card.type === 'expert'">
                                  <el-tooltip class="item" effect="dark" :content="card.nickname" placement="top">
                                    <div class="card-container">
                                      <img class="avatar" :src="card.avatar ? 'https://api.goucaiwang888.com' + card.avatar : require('@/assets/avatar.png')" alt="avatar" />
                                      <p class="name">{{ card.nickname }}</p>
                                      <p class="hit">总命中 <b class="hit-num">{{ card.total_hit }}</b></p>
                                    </div>
                                  </el-tooltip>
                                </template>

                                <!-- 查看更多卡片（和专家卡片等尺寸） -->
                                <template v-else>
                                  <span class="more-text">查看更多</span>
                                </template>
                              </div>
                            </div>
                        </div>
                        <div class="downEwmBlock mt10">
                            <div class="titleI">
                                <h2>手机客户端</h2>
                            </div>
                            <div class="ttzs app" @click="goDown">
                                <!-- <div class="info">
                                    <img src="../assets/companyIcon.png">
                                    <div class="txt">
                                        <h2>购彩网APP</h2>
                                        <p>好用的彩票走势图</p>
                                    </div>
                                </div>
                                <p>手机看开奖看走势<br>随时随地。</p>
                                <el-button style="margin-top: 20px;" type="danger">立即下载APP</el-button>
                                <div class="ewm">
                                    <img src="../assets/appQR.png">
                                </div> -->
                                <img src="../assets/AppPic.jpg" alt="">
                            </div>
                        </div>
                        <div class="downEwmBlock mt10">
                            <div class="titleI">
                                <h2>关注公众号</h2>
                            </div>
                            <div class="ttzs">
                                <img src="../assets/officialPic.jpg" alt="">
                                <!-- <div class="info">
                                    <img src="../assets/companyIcon.png">
                                    <div class="txt">
                                        <h2>购彩网公众号</h2>
                                        <p>即时数字彩资讯</p>
                                    </div>
                                </div>
                                <p>扫码关注公众号<br>走势图走到哪看到哪。</p>
                                <div class="ewm">
                                    <img src="../assets/officialQR.png">
                                </div> -->
                            </div>
                        </div>
                        <div class="downEwmBlock mt10">
                            <div class="titleI">
                                <h2>关注快手号</h2>
                            </div>
                            <div class="ttzs">
                                <img src="../assets/Kwai.jpg">
                            </div>
                        </div>
                        <div class="downEwmBlock mt10">
                            <div class="titleI">
                                <h2>关注抖音号</h2>
                            </div>
                            <div class="ttzs">
                                <img src="../assets/TiktokPic.jpg">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="wrap1200 mt20">
            <div class="trendEntry mt20">
                <div class="titleI">
                    <h2>走势图</h2>
                    <el-button size="mini" plain round>更多</el-button>
                </div>
                <ul>
                    <li v-for="(item,index) in this.lotteryData.lottery?this.lotteryData.lottery.slice(0, 4):[]">
                        <div class="type">
                            <a href="#" target="_blank">
                                <div class="img">
                                    <img v-if="item.lottery_name == '双色球'" src="../assets/type01.png">
                                    <img v-if="item.lottery_name == '大乐透'" src="../assets/type02.png">
                                    <img v-if="item.lottery_name == '福彩3D'" src="../assets/type03.png">
                                    <img v-if="item.lottery_name == '排列三'" src="../assets/type04.png">
                                </div>
                                <h4>{{ item.lottery_name }}</h4>
                            </a>
                        </div>
                        <div class="link">
                            <a v-for="el in item.zoushi.slice(0,4)" href="#">{{ el.label }}</a>
                        </div>
                    </li>
                </ul>
                <div class="otherLink">
                    <h5>其他彩种</h5>
                    <div class="otherUl">
                        <a v-for="el in this.lotteryData.lottery?this.lotteryData.lottery.slice(4,10):[]" href="#">{{el.lottery_name}}走势图</a>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import { getIndexList,getCategoryList} from '@/api/index';
import { getExpertList,postExpertContent} from '@/api/expert';
export default {
  data() {
    return {
        currentLeagueIcon: 'footballIcon01.png', // 默认图片
        leagues: [
            { name: '中超', icon: 'footballIcon02.png' },
            { name: '英超', icon: 'footballIcon01.png' },
            { name: '西甲', icon: 'footballIcon03.png' },
            { name: '德甲', icon: 'footballIcon05.png' },
            { name: '意甲', icon: 'footballIcon06.png' },
            { name: '法甲', icon: 'footballIcon04.png' },
            { name: '欧冠', icon: 'footballIcon07.png' },
        ],
        expertData: [],
        expertContent:[],
        lotteryData:[],
        categoryData:[],
        dltCategory:[],
        ssqCategory:[],
        fcsdCategory:[],
        plsCategory:[],
        activeTab: "1",          // Tab 当前激活项
        killList: [],               // 杀号列表
        recommendList: [],          // 推荐号列表
    };
  },
  computed: {
    gridExperts() {
       if (this.expertData.length <= 5) {
         return this.expertData.map(e => ({ ...e, type: 'expert' }));
       } else {
         const experts = this.expertData.slice(0, 5).map(e => ({ ...e, type: 'expert' }));
         experts.push({ type: 'more' });
         return experts;
       }
    }
  },
  methods: {
     handleCardClick(card) {
        console.log(card.type,'card.type');
        if (card.type === 'expert') {
          // 跳转到专家详情页
          this.$router.push({path: '/expertDetail', query: { expert_id: card.expert_id }});
        } else if (card.type === 'more') {
          // 跳转到更多专家页
          this.$router.push('/expertList');
        }
    },
    handleTabClick(tab) {
         console.log('切换到 Tab:', tab.name);
         this.activeTab = tab.name;
         this.getExpertContentList(); // 切换 Tab 时刷新内容
    },
    goCourse(curIndex,selectedIndex){
        this.$router.push({
            path: '/course',
            query: {
                curIndex: curIndex,
                selectedIndex: selectedIndex
            }
        });
    },
    goToVideoPage(videoId) {
        // 使用query参数传递视频ID
        this.$router.push({
            path: '/using', // 替换为B页面的实际路径
            query: { video_id: videoId }
        });
    },
    goDown(){
        window.location.href = 'https://api.goucaiwang888.com/api/ver/download';
    },
    goVideo(){
        this.$router.push('/using');
    },
    goArticle(){
        this.$router.push('/service');
    },
    goArticleDetil(id){
        this.$router.push({
            path: '/service/articleDetail',
            query: { id: id }
        });
    },
    goExpertDataInfo(id) {
				console.log(this.current)
			  if(Number(this.activeTab)==1)
				{
					this.$router.push({
					    path: '/killno',
					    query: { id: id }
					});
				}
				else
				{
					this.$router.push({
					    path: '/recommend',
					    query: { id: id }
					});
				}
		},
    goMoreExpertData(){
        this.$router.push({
            path: Number(this.activeTab)==1?'/moreKillno':'/moreRecommend',
            query: { type: Number(this.activeTab) }
        });
    },
    indexLotteryList() {
        getIndexList().then(res => {
            // console.log(res,'res')
            this.lotteryData = res.data.data;
            // console.log(this.lotteryData,'this.lotteryData')
        })
        .catch(error => {
          console.error('Error fetching user list:', error);
        });
    },
    getExpertListData() {

        getExpertList({limit:6}).then(res => {
            console.log(res,'getExpertListData')
            this.expertData = res.data.data.list;
            console.log(this.expertData,'this.expertData')
        })
        .catch(error => {
          console.error('Error fetching user list:', error);
        });
    },
    getExpertContentList() {
        postExpertContent({type:Number(this.activeTab),limit:6}).then(res => {
            console.log(res,'getExpertContentList')
            this.expertContent = res.data.data.list;
            console.log(this.expertContent,'this.expertData')
        })
        .catch(error => {
          console.error('Error fetching user list:', error);
        });
    },
    categoryList(){
        getCategoryList().then(res => {
            this.categoryData = res.data.data;
        })
        .catch(error => {
          console.error('Error fetching user list:', error);
        });
        getCategoryList({page:1,cid:17}).then(res => {
            this.dltCategory = res.data.data;
        })
        .catch(error => {
          console.error('Error fetching user list:', error);
        });
        // getCategoryList({page:1,cid:17}).then(res => {
        //     this.dltCategory = res.data.data;
        // })
        // .catch(error => {
        //   console.error('Error fetching user list:', error);
        // });
    },
    //奖池滚存转换
    formatAmount(amount) {
      const billion = Math.floor(amount / 100000000); // 亿的部分
      const million = Math.floor((amount % 100000000) / 10000); // 万的部分
      const yuan = (amount % 10000).toFixed(0); // 元的部分

      let formatted = '';
      if (billion > 0) {
        formatted += `<span class="red">${billion}</span>亿`;
      }
      if (million > 0) {
        formatted += `<span class="red">${million}</span>万`;
      }
      if (yuan > 0) {
        formatted += `<span class="red">${yuan}</span>元`;
      }

      return formatted;
    },
    getStatusText(status) {
        switch (status) {
          case 0: return 'NEW';
          case 1: return '已命中';
          case 2: return '未命中';
          default: return '';
        }
    },
    getStatusClass(status) {
    	switch (status) {
    	  case 0: return 'badge-miss';
    	  case 1: return 'badge-hit';
    	  case 2: return 'badge-pending';
    	  default: return '';
    	}
    },
    getExpertLevelImg(level) {
    	switch (level) {
    	  case 1: return '/static/imgs/expert/level1.png';
    	  case 2: return '/static/imgs/expert/level2.png';
    	  case 3: return '/static/imgs/expert/level3.png';
    	  case 4: return '/static/imgs/expert/level4.png';
    	  case 5: return '/static/imgs/expert/level5.png';
    	  default: return '';
    	}
    },
  },
  mounted() {
    this.indexLotteryList();
    this.categoryList();
    this.getExpertListData();
    this.getExpertContentList();
  },
};
</script>
<style scoped>
.wrap1200 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}
.pt20 {
    padding-top: 20px;
}
.mt10 {
    margin-top: 10px;
}
.mt15 {
    margin-top: 15px;
}
.mt20 {
    margin-top: 20px;
}
.w260{
    width: 260px;
}
.w920 {
    /* width: 920px; */
    width: 1200px;
}
.fl {
    float: left;
    display: inline;
}
.fr {
    float: right;
    display: inline;
}
.aSideNotice {
    background: #fff;
    border-radius: 8px;
}
.titleI {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    height: 28px;
    line-height: 28px;
}
.titleI h2 {
    display: flex;
    align-items: center;
    flex: 1;
    font-size: 20px;
}
.el-button.is-plain:focus, .el-button.is-plain:hover {
    background: #FFF;
    border-color: #EA4747;
    color: #EA4747;
}
.liveEntry {
    display: flex;
    justify-content: space-between;
    /* padding: 0 10px; */
    /* border-bottom: 1px solid #eee; */
}
a:hover {
    text-decoration: none;
}
.liveEntry a {
    position: relative;
    box-sizing: border-box;
    display: block;
    padding: 10px 12px;
    margin-bottom: 10px;
    height: 110px;
    border-radius: 8px;
    overflow: hidden;
    width: 49%;
}
.liveEntry a::after {
    content: "";
    position: absolute;
    right: -14px;
    bottom: -6px;
    width: 64px;
    height: 64px;
}
.liveEntry a.red {
    /* background: linear-gradient(132deg, #ea4747 0%, #fd7a7a); */
    background: url("../assets/LiveBg01.png");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
}
.liveEntry a.orange {
    /* background: linear-gradient(132deg, #ff8741 3%, #ffa83e); */
    background: url("../assets/liveBg02.png");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
}
.liveEntry a.red .liveSmall{
    background: url("../assets/liveSBg01.png");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    padding: 10px;
    border-radius: 8px;
}
.liveEntry a.orange .liveSmall{
    background: url("../assets/liveSBg02.png");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    padding: 10px;
    border-radius: 8px;
}
.liveEntry h3 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
    margin-bottom: 3px;
    color: #ad3e1b;
}
.liveEntry .orange h3 {
    color: #a0610f;
}
.liveEntry .liveSmall p {
    line-height: 17px;
    opacity: .7;
    color: #852d10;
    line-height: 24px;
}
.liveEntry .orange .liveSmall p{
    color: #935401;
}
/* @keyframes fadeInLeftP {
    from {
        opacity: 0;
        transform: translateX(-20px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}
@keyframes fadeInRight {
    from {
        opacity: 0;
        transform: translateX(100%);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}
.liveEntry a:hover p {
    animation: fadeInLeftP .5s .08s ease both;
    -webkit-animation: fadeInLeftP .5s .08s ease both;
}
.liveEntry a.red.liveSmall::after {
    background: url("../assets/liveSbg01.png");
    background-size: 100% 100%;
}
.liveEntry a.orange::after {
    background: url("../assets/type02.png");
    background-size: 100% 100%;
}
.liveEntry a:hover::after {
    animation: fadeInRight .5s ease both;
    -webkit-animation: fadeInRight .5s ease both;
} */
.drawPrize{
    padding: 0 8px 10px 8px ;
}
.drawPrize ul{
    list-style: none;
}
.drawPrize ul li {
    padding: 7px 12px;
    /* border-bottom: 1px solid #eee; */
    background: url("../assets/drawItemBg.png");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 8px;
    margin-top: 4px;
}
.drawPrize h4 {
    display: flex;
    height: 20px;
    align-items: center;
    font-size: 14px;
    color: #999;
    font-weight: normal;
}
.drawPrize h4 a {
    font-weight: bold;
    color: #333;
}
.ml10 {
    margin-left: 10px;
}
.drawPrize h4 em {
    margin-left: auto;
}
.drawPrize .nub {
    display: flex;
    align-items: center;
    height: 21px;
    margin-top: 10px;
    position: relative;
    overflow: hidden;
}
.marquee {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
}

.marquee-inner {
    display: inline-block;
    animation: marquee 30s linear infinite;
}

.marquee-inner:hover {
    animation-play-state: paused;
}

@keyframes marquee {
    0% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(-100%);
    }
}

.marquee span {
    display: inline-block;
    margin-right: 20px; /* 调整数字间距 */
}
.drawPrize .nub span {
    font-size: 18px;
    font-family: 'DIN Alternate';
    margin-right: 8px;
    color: #EA4747;
}
.drawPrize .nub span.blue {
    color: #0F88EB;
    background: none;
}
.drawPrize .nub a {
    color: #333;
    margin-left: auto;
}
.drawPrize p {
    display: flex;
    height: 18px;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #333;
    margin-top: 8px;
}
.red {
    color: #e60012;
}
.drawPrize p em {
    display: block;
    width: 62px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: #FFD0D0;
    font-size: 10px;
    color: #EA4747;
    border-radius: 10px;
    transform: scale(.8);
    transform-origin: right center;
}
.bannerI {
    height: 310px;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
}
.bannerI img{
    width: 100%;
    height: 100%;
}
.centerCon{
    margin-top: 10px;
}
.newsInfo {
    width: 890px;
    /* width: 600px; */
    /* height: 440px; */
}
.newsInfo .newsMain{
    background: #FFFFFF;
    border-radius: 8px;
}
.newsInfolist {
    padding: 0 20px;
}
.newsInfolist dt {
    margin-bottom: 10px;
    line-height: 25px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
    font-size: 18px;
    font-weight: 800;
    text-align: justify;
}
.newsInfolist dt a {
    display: block;
    color: #EA4747;
    height: 25px;
    overflow: hidden;
}
.newsInfolist a:hover {
    text-decoration: underline;
}
.newsInfolist dd {
    font-size: 16px;
    height: 32px;
    line-height: 32px;
    overflow: hidden;
    text-align: justify;
}
.newsInfolist dd a {
    color: #333;
}
.newsInfolist dd span {
    margin: 0 3px;
    color: #eee;
}
.courseMain{
    background: #FFFFFF;
    border-radius: 8px;
    margin-bottom: 8px;
}
.courseMain ul{
    display: flex;
    justify-content: space-between;
    width: 95%;
    margin: 0 auto;
    li{
        width: 24%;
        list-style: none;
        border-radius: 8px;
        img{
            width: 100%;
            border-radius: 8px;
        }
    }
}
.footballMain{
    background: #FFFFFF;
    border-radius: 8px;
    margin-bottom: 8px;
    padding-bottom: 10px;
}
.footballMain ul{
    width: 95%;
    margin: 0 auto;
    .footballItem {
        width: 100%;
        height: 46px;
        line-height: 46px;
        background: #f5f5f5;
        border-radius: 8px;
        display: flex;
        margin-bottom: 10px;
        .footballTitle {
            color: #FFFFFF;
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            width: 128px;
            height: 100%;
            background-size: contain !important;
            background-repeat: no-repeat !important;
            background-position: left center !important;
        }
        .footballList{
            width: 80%;
            height: 46px;
            padding: 12px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            .listItem {
                width: 100%;
                height: 100%;
                display: flex !important;
                flex-flow: row wrap !important;
                align-items: center !important;
                justify-content: center !important;
                div {
                    width: 20%;
                    height: 100%;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    line-height: 1;
                    border-right: 1px dashed #525252;
                    cursor: pointer;
                }
                div:last-child {
                    border-right: none;
                }
            }
        }
    }
}
.listItem {
    width: 100%;
    height: 100%;
    display: flex !important;
    flex-flow: row wrap !important;
    align-items: center !important;
    justify-content: center !important;

}
.listItem div {
    width: 20%;
    height: 100%;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    line-height: 1;
    border-right: 1px dashed #525252;
    cursor: pointer;
}
.listItem div:last-child {
    border-right: none;
}
.downEwmWrap {
    width: 300px;
    /* height: 440px; */
}
.downEwmBlock {
    background: #fff;
    border-radius: 8px;
    .titleI{
        padding: 3px 20px;
        h2{
            font-size: 18px;
        }
    }
}
.downEwmBlock .ttzs.app {
    /* width: 280px;
    height: 201px; */
    margin: 0 auto;
    /* background: linear-gradient(180deg, #fff8f8, #ffffff); */
    /* background: url("../assets/appEwmBg.png"); */
}
.downEwmBlock .ttzs {
    box-sizing: border-box;
    position: relative;
    border-radius: 6px;
    /* height: 170px; */
    padding: 0px 10px 6px 10px;
    img{
        width: 100%;
    }
}
.downEwmBlock .info {
    color: #333;
}
.downEwmBlock .info img {
    float: left;
    margin-right: 8px;
    width: 48px;
    height: 48px;
}
.downEwmBlock .ttzs > p {
    font-size: 14px;
    line-height: 20px;
    color: #999;
    margin-top: 12px;
}
.downEwmBlock .ewm {
    box-sizing: border-box;
    position: absolute;
    right: 20px;
    bottom: 20px;
    width: 100px;
    height: 100px;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #eee;
}
.downEwmBlock .ttzs.app .ewm {
    right: 10px;
}
.downEwmBlock .ewm img {
    width: 100%;
    height: 100%;
}
.trendEntry {
    background: #fff;
    border-radius: 8px;
}
.flexBetween{
    display: flex;
    justify-content: space-between;
}
.trendEntry ul {
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.trendEntry ul li {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 275px;
    height: 90px;
    background: #f5f5f5;
    border-radius: 8px;
}
.trendEntry .type {
    width: 92px;
}
.trendEntry .type a {
    display: block;
}
.trendEntry .type .img {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    width: 48px;
    height: 48px;
    box-sizing: border-box;
    border: 1px solid #eee;
    border-radius: 8px;
    background: #fff;
}
.trendEntry .type .img img {
    display: block;
    width: 32px;
    height: 32px;
}
.trendEntry .type h4 {
    font-size: 12px;
    color: #333;
    margin-top: 4px;
    line-height: 18px;
    text-align: center;
}
@keyframes bounceIn {
    0% {
        opacity: 0;
        transform: scale(0.3);
    }
    20% {
        transform: scale(1.1);
    }
    40% {
        transform: scale(0.9);
    }
    60% {
        opacity: 1;
        transform: scale(1.03);
    }
    80% {
        transform: scale(0.97);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}
.trendEntry .type a:hover .img img, .typeTabI a:hover img {
    animation: bounceIn .8s ease both;
    -webkit-animation: bounceIn .8s ease both;
}
.trendEntry .link {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
}
.trendEntry .link a {
    width: 50%;
    padding: 5px 0;
    line-height: 20px;
    color: #333;
}
.trendEntry .link a:hover {
    text-decoration: underline;
}
.trendEntry .otherLink {
    padding: 24px 20px;
}
.trendEntry .otherLink h5 {
    font-size: 14px;
    margin-bottom: 10px;
}
.trendEntry .otherUl {
    display: flex;
    flex-wrap: wrap;
}
.trendEntry .otherUl a {
    display: block;
    font-size: 12px;
    margin-right: 15px;
    line-height: 18px;
    color: #333;
}

/* 统一两边留白，网格栅格 & 间距 */
.expert-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 侧栏宽度≈300px：默认 2 列 */
  gap: 12px;
  padding: 0 10px 12px;
}

/* 如果把这块移到主内容区域（宽度更大），自动 3 列并居中显示 */
@media (min-width: 760px) {
  .wrap1200 .w920 .expert-grid {
    max-width: 900px;
    grid-template-columns: repeat(3, 1fr);
    margin: 0 auto; /* 居中 */
  }
}

/* 卡片尺寸一致（含“查看更多”） */
.expert-card {
  width: 85px;        /* 固定卡片宽度（根据你设计调整，比如120/150） */
  box-sizing: border-box;
  background: #f9f9f9;
  border-radius: 10px;
  height: 132px;                 /* ⇦ 调矮一些，更紧凑 */
  padding: 12px 8px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;       /* 垂直居中内容 */
  align-items: center;
  transition: transform .18s ease;
  cursor: pointer;
}
.expert-card:hover { transform: translateY(-3px); }

/* 头像：圆形 + 浅色描边 */
.avatar {
  width: 55px;      /* 可根据需求调整 */
  height: 55px;      /* 保持宽高一致 */
  border-radius: 0;  /* 关键：正方形 */
  object-fit: cover; /* 保持图片填充，防止拉伸 */
  border: 2px solid #eee; /* 可选：浅色描边 */
  border-radius: 50%;

}

.name {
  width: 100%;              /* 让名字在卡片宽度内统一 */
  text-align: center;       /* 居中显示 */
  font-size: 14px;
  color: #333;
  margin: 6px 0;
  white-space: nowrap;      /* 不换行 */
  overflow: hidden;         /* 超出隐藏 */
  text-overflow: ellipsis;  /* 超出显示省略号 */
}

.hit {
  font-size: 12px;
  color: #666;
  text-align: center;
}

.hit-num {
  font-size: 18px;
  color: red;
  font-weight: bold;
  font-style: italic; /* 文字斜体 */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* 文字阴影 */
}
.hit b{ font-weight: 700; color: red; }

/* “查看更多” 卡片：与专家卡片同高同宽 */
.expert-card.more {
  background: #eef5ff;
  color: #409eff;
  font-weight: 600;
}
.more-text { font-size: 14px; letter-spacing: 1px; }


.expert-list {
  display: flex;
  gap: 16px;
  flex-wrap: nowrap;     /* 不换行，始终一行显示 */
  overflow-x: auto;      /* 如果超过屏幕宽度，可以横向滚动 */
  padding: 10px 0;
}

.expert-data-card {
  flex: 0 0 240px;       /* 每个卡片固定宽度 */
  display: flex;
  align-items: flex-start;
  padding: 12px;
  border: 1px solid #eee;
  border-radius: 12px;
  background: #fff;
  transition: box-shadow 0.3s ease;
}

.expert-data-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  /* margin-right: 10px; */
}

.info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.top {
  font-size: 12px;
  /* font-weight: bold; */
  margin-bottom: 2px;
}

.nickname {
  margin-right: 6px;
}

.expert-level {
  color: #D32E00;
  font-size: 14px;
  font-weight: bold;
 /* font-style: italic; */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.lottery {
  font-size: 12px;
  color: #666;
  margin-bottom: 2px;
  text-align: right; /* 让文字靠右 */
}

.title {
  font-size: 14px;
  color: #333;
  font-weight: bold;
  margin-bottom: 2px;
  /* font-weight: 500; */
}

.footer {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
}
.badge-pending { color: #999;  font-size: 18px; font-weight: bold; font-weight: bold; font-style: italic; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); }      /* 未命中 */
.badge-hit    { color: #28a745; font-size: 18px; font-weight: bold; font-weight: bold; font-style: italic; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); }    /* 命中 */
.badge-miss   { color: #ff4d4f;  font-size: 18px; font-weight: bold;  font-weight: bold; font-style: italic; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); }    /* 未开奖 */

</style>



// WEBPACK FOOTER //
// src/views/index.vue